/**
 * Fan identity paint for the initials avatar (ISSUE-1111).
 *
 * The plate is identity and never status. One table serves light and dark,
 * like `primarySolid`, so a fan keeps one color when the device switches mode.
 * Each fill is the lightest existing step of its hue that holds white letters
 * at 4.5:1. The order of the table is part of the contract: reordering it
 * repaints every fan. This module imports nothing platform specific so the
 * native entry can re-export it later.
 */
import { contestShadeIndex } from "./contest";
import { palette, tokens } from "./tokens";

export type typeAvatarPlate = {
  readonly fill: string;
  readonly on: string;
};

export const avatarPlates: readonly typeAvatarPlate[] = [
  { fill: palette.brand[500], on: palette.neutral[0] },
  { fill: palette.stadium[550], on: palette.neutral[0] },
  { fill: palette.orange[600], on: palette.neutral[0] },
  { fill: palette.green[600], on: palette.neutral[0] },
  { fill: palette.red[500], on: palette.neutral[0] },
  { fill: palette.blue[500], on: palette.neutral[0] },
  { fill: palette.pink[500], on: palette.neutral[0] },
  { fill: palette.purple[400], on: palette.neutral[0] },
];

export const AVATAR_PLATE_FALLBACK: typeAvatarPlate = {
  fill: tokens.color.light.primarySolid,
  on: tokens.color.light.onPrimary,
};

export const normalizeAvatarName = (displayName: string): string =>
  displayName.trim().replace(/\s+/g, " ").toLowerCase();

export const avatarPlateForName = (displayName: string): typeAvatarPlate => {
  const normalized = normalizeAvatarName(displayName);
  if (normalized === "") return AVATAR_PLATE_FALLBACK;
  return (
    avatarPlates[contestShadeIndex(normalized, avatarPlates.length)] ??
    AVATAR_PLATE_FALLBACK
  );
};
